function bootReveal(root) {
  const nodes = [...root.querySelectorAll('[data-reveal]')];
  if (!nodes.length) return () => {};
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    nodes.forEach((node) => node.classList.add('is-in'));
    return () => {};
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      });
    },
    { threshold: 0.14, rootMargin: '0px 0px -8% 0px' }
  );
  nodes.forEach((node) => io.observe(node));
  return () => io.disconnect();
}

function bootAbout(root) {
  if (!root || root.dataset.booted === '1') return;
  root.dataset.booted = '1';
  const cleanup = bootReveal(root);
  root._artinkAboutCleanup = () => {
    cleanup();
    root.dataset.booted = '0';
  };
}

function initAll() {
  document.querySelectorAll('[data-artink-about]').forEach(bootAbout);
}

initAll();
document.addEventListener('shopify:section:load', (event) => {
  event.target.querySelectorAll('[data-artink-about]').forEach(bootAbout);
});
document.addEventListener('shopify:section:unload', (event) => {
  event.target.querySelectorAll('[data-artink-about]').forEach((root) => {
    root._artinkAboutCleanup?.();
  });
});
